export default __webpack_public_path__ + "static/binance-a1cf163407c40f5d5fe9d61065ed43c6.png";